import { createTheme, responsiveFontSizes } from '@material-ui/core/styles';
import { yellow } from '@material-ui/core/colors';

declare module '@material-ui/core/styles/createTheme' {
  interface Theme {
    colors: {
      primary: string,
      background: string,
      backgroundLight: string
      win: string,
      loss: string,
      whiteWeak: string
    };
    borderRadius: string,
  }
  interface ThemeOptions {
    colors: {
      primary: string,
      background: string,
      backgroundLight: string
      win: string,
      loss: string,
      whiteWeak: string
    };
    borderRadius: string,
  }
}

let theme = createTheme({
  palette: {
    type: 'dark',
    primary: {
      main: yellow[400],
    },
    background: {
      default: '#1E2141',
    },
  },
  overrides: {
    MuiTooltip: {
      tooltip: {
        backgroundColor: '#1E2141',
        color: '#ffffffdd',
        fontSize: '12px',
        fontWeight: 500,
        padding: '8px 14px',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
      },
    },
  },
  colors: {
    primary: yellow[400],
    background: '#1E2141',
    backgroundLight: '#2C325C',
    win: '#4BDC4B',
    loss: '#FF6347',
    whiteWeak: '#ffffff99',
  },
  borderRadius: '10px',
});

export default theme = responsiveFontSizes(theme);
